import type { FC } from "react";

import type { BaseIconProps } from "@/assets/icons/utils";

export const IconMCP: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.37931 7.5321L7.62136 1.29006C8.48322 0.428215 9.88055 0.428215 10.7423 1.29006C11.6042 2.1519 11.6042 3.54924 10.7423 4.41108L6.02833 9.12513"
                        stroke="currentColor"
                        strokeLinecap="round"
                    />
                    <path
                        d="M6.09336 9.06007L10.7423 4.41103C11.6042 3.54919 13.0016 3.54919 13.8634 4.41103L13.8959 4.44354C14.7578 5.30539 14.7578 6.70272 13.8959 7.56456L8.25056 13.21C7.96327 13.4972 7.96327 13.963 8.25056 14.2502L9.40975 15.4095"
                        stroke="currentColor"
                        strokeLinecap="round"
                    />
                    <path
                        d="M9.18189 2.85059L4.56536 7.4671C3.70352 8.32892 3.70352 9.72625 4.56536 10.5881C5.4272 11.4499 6.82454 11.4499 7.68639 10.5881L12.3029 5.97161"
                        stroke="currentColor"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1.72414 9.4151L9.5267 1.61255C10.604 0.535238 12.3507 0.535238 13.4279 1.61255C14.5053 2.68985 14.5053 4.43651 13.4279 5.51382L7.53541 11.4064"
                        stroke="currentColor"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M7.6167 11.3251L13.4279 5.51379C14.5053 4.43648 16.252 4.43648 17.3293 5.51379L17.3699 5.55443C18.4472 6.63174 18.4472 8.3784 17.3699 9.4557L10.3132 16.5125C9.95409 16.8715 9.95409 17.4537 10.3132 17.8128L11.7622 19.2619"
                        stroke="currentColor"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M11.4774 3.56323L5.70669 9.33388C4.62939 10.4112 4.62939 12.1578 5.70669 13.2352C6.784 14.3124 8.53066 14.3124 9.60797 13.2352L15.3786 7.46451"
                        stroke="currentColor"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.06896 11.2982L11.432 1.93516C12.7248 0.642383 14.8208 0.642383 16.1135 1.93516C17.4063 3.22791 17.4063 5.32391 16.1135 6.61669L9.04249 13.6878"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                    />
                    <path
                        d="M9.14005 13.5902L16.1135 6.61667C17.4063 5.3239 19.5023 5.3239 20.7952 6.61667L20.8439 6.66543C22.1367 7.9582 22.1367 10.0542 20.8439 11.347L12.3758 19.8151C11.9449 20.246 11.9449 20.9446 12.3758 21.3755L14.1146 23.1144"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                    />
                    <path
                        d="M13.7728 4.27588L6.84803 11.2007C5.55527 12.4934 5.55527 14.5894 6.84803 15.8822C8.1408 17.1749 10.2368 17.1749 11.5296 15.8822L18.4543 8.95741"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                    />
                </svg>
            );
    }
};
